import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { ButtonTypeEnum } from '@panaya/ui/p-button';

@Component({
    selector: 'p-chip',
    template: `
        <div class="p-chip p-paragraph-1" [class.live]="true" [class.mark-as-hover]="shouldMarkAsHover">
            <p-icon class="p-input-link-prefix" matPrefix *ngIf="!!icon && iconPosition === 'left'" [name]="icon" size="sm"></p-icon>
            <span class="p-chip-label">
                {{ label }}
            </span>
            <p-icon class="p-input-link-suffix" matSuffix *ngIf="!!icon && iconPosition === 'right'" [name]="icon" size="xs"></p-icon>
            <p-button
                *ngIf="iconRemove"
                class="p-chip-remove"
                [ariaLabel]="'Remove hashtag ' + label"
                [buttonType]="buttonType.IsIcon"
                iconBefore="x"
                iconBeforeSize="xs"
                (click)="onRemove.emit($event)"
            ></p-button>
        </div>
    `,
    styleUrls: ['./p-chip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PChipComponent implements OnInit {
    @Input() label?: string;
    @Input() iconRemove = false;
    @Input() shouldMarkAsHover = false;
    @Input() icon?: string;
    @Input() iconPosition: 'left' | 'right' = 'left';
    @Output() onRemove: EventEmitter<any> = new EventEmitter();
    public buttonType = ButtonTypeEnum;

    constructor() {}

    ngOnInit(): void {}
}
